import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { EventWithRelationsDto, ResponseDto } from "@mimber/schema"
import { eventsKeys } from "../events.utils"

export const useEvent = (
  uuid: string,
  options?: UseQueryOptions<ResponseDto<EventWithRelationsDto>, Error>
): UseQueryResult<ResponseDto<EventWithRelationsDto>, Error> => {
  guardAppUsage("mimber-organization", "useEvent")

  const { server } = useServerContext()

  return useQuery({
    queryKey: eventsKeys.findOne(uuid),
    queryFn: async () => {
      const response = await server.get<ResponseDto<EventWithRelationsDto>>(
        `events/${uuid}`
      )
      return response.data
    },
    staleTime: 1 * 60 * 1000,
    enabled: !!uuid,
    ...options,
  })
}
